
const Link = {
    ApaFrance: "https://sfp-apa.fr/annuaire/#containerPrincipal"
}

export default Link